// **Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// constants
const blacklisteTableFilterInitialValue = {
  page: 0,
  name: '',
  query: '',
  sortBy: 'domain',
  sortDir: 'asc',
  pageSize: 50
}
const tenantsTableFilterInitialValue = {
  pageSize: 50,
  page: 0,
  sortBy: 'name',
  sortDir: 'asc'
}

export const developerSlice = createSlice({
  name: 'developer',
  initialState: {
    blacklistedDomainFilters: { ...blacklisteTableFilterInitialValue },
    tenantsFilters: { ...tenantsTableFilterInitialValue }
  },
  reducers: {
    setBlacklistedTableFilters(state, action) {
      state.blacklistedDomainFilters = action.payload
    },
    setTenantsTableFilters(state, action) {
      state.tenantsFilters = action.payload
    }
  }
})

export const { setBlacklistedTableFilters, setTenantsTableFilters } =
  developerSlice.actions

export default developerSlice.reducer
